import { useState } from 'react';
import { useSelector } from 'react-redux';
import { developerApplicationSelector } from '../../../../store';
import Button from '../../../UI/Button';
import CompanyCompletedProject from './CompanyCompletedProject';
import PrincipalCompletedProject from './PrincipalCompletedProject';

export default function Experience({
  nextHandler,
  previousHandler,
}: {
  nextHandler: () => void;
  previousHandler: () => void;
}) {
  const { experience } = useSelector(developerApplicationSelector);
  const [formError, setFormError] = useState('');

  const requirementsAreMet = () => {
    if (
      experience.companyCompleted.length > 0 ||
      experience.principalCompleted.length > 0
    ) {
      return true;
    }
    setFormError('Projects are required in either one of the above section.');
    return false;
  };

  const handlePrevious = () => {
    previousHandler();
    // const isValid = requirementsAreMet();
    // if (isValid) {
    // }
  };

  const handleNext = () => {
    const isValid = requirementsAreMet();
    if (isValid) {
      nextHandler();
    }
  };

  return (
    <div className='space-y-6 p-6 lg:col-span-8 rounded-md'>
      <h3 className='text-lg leading-6 font-medium text-primaryColor-normal'>
        Experience
      </h3>
      <CompanyCompletedProject />
      <PrincipalCompletedProject />
      <p className='text-tertiaryColor-normal'>{formError}</p>
      <div className='flex gap-4 justify-end'>
        <Button
          label='Previous'
          btnStyle='btn-neutral'
          type='button'
          onClick={handlePrevious}
        />
        <Button
          label='Next'
          btnStyle='btn-primary'
          type='button'
          onClick={handleNext}
        />
      </div>
    </div>
  );
}
